import { Component } from '@angular/core';
import { BackButtonComponent } from '../../../components/utility/back-button/back-button.component';
import { BhashiniLanguageTranslationComponent } from '../../../components/utility/bhashini-language-translation/bhashini-language-translation.component';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { routes } from '../../../constants/routes';
import { apiErrorHandler } from '../../../constants/api-error-handler';
import { ApiService } from '../../../services/api.service';
import { UtilityService } from '../../../services/utility.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-register-step-1',
  standalone: true,
  imports: [BackButtonComponent, BhashiniLanguageTranslationComponent, CommonModule],
  templateUrl: './register-step-1.component.html',
  styleUrl: './register-step-1.component.scss',
})
export class RegisterStep1Component {
  parichayAuthSubs: Subscription;
  explorerRole = {
    icon: 'images/individual-auth.svg',
    title: 'Explorer Role',
    description: 'View and request downloads of artifacts on the platform',
    permissions: [
      'Browse all public artifacts',
      'Request artifact downloads',
      'Save favorites for later',
      'Explore Compute Features',
    ],
    recommendation: 'Recommended for researchers, students, and general users',
    buttonText: 'Select Explorer',
    role: 'explorer',
  };

  contributorRole = {
    icon: 'images/contributor.svg',
    title: 'Contributor',
    description: 'Upload, share, and manage your own artifacts',
    permissions: [
      'All Explorer features',
      'Upload and publish artifacts',
      'Manage your submissions',
      'Collaborate with others',
    ],
    recommendation: 'Recommended for verified users who want to share content',
    buttonText: 'Continue with Jan Parichay',
    role: 'contributor',
  };

  organizationAdminRole = {
    icon: 'images/org-auth.svg',
    title: 'Organization Admin',
    description: 'Manage organization accounts and team members',
    permissions: [
      'All Contributor features',
      'Create and manage organizations',
      'Create and manage organizations',
      'Add team members',
    ],
    recommendation: 'For organization owners with verified accounts',
    note: 'Note: You must own an organization',
    buttonText: 'Continue with Jan Parichay',
    role: 'organizationAdmin',
  };

  constructor(
    private router: Router,
    private utilService: UtilityService,
    private apiService: ApiService,
  ) {}

  redirectToHome() {
    this.router.navigate(['/']);
  }

  moveToStep2(role: string) {
    if (role === 'explorer') {
      this.router.navigate([routes.account, routes.register, routes.step2], {
        queryParams: { role },
      });
      return;
    }
    this.getJanParichayUrl();
  }

  getJanParichayUrl() {
    this.parichayAuthSubs = this.apiService.fetchJanParichayAuth().subscribe({
      next: (res) => {
        const parichayUrl = res;
        this.utilService.openExternalPage(parichayUrl);
      },
      error: apiErrorHandler.bind(this),
    });
  }

  redirectToLogin() {
    this.router.navigate(['/', routes.account, routes.user, routes.login]);
  }
}
